<template>
  <div id="main">
    <div id="manu">
      <navigation />
    </div>
    <div id="contentBox">
      <div class="registervideoContainer"></div>
      <div class="w">
        <div class="shousuo">
          <input
            type="text"
            class="input__search"
            v-model="keywords"
            @keydown.enter="search"
            @keyup="getData($event)"
            @focus="isShow = true"
            @blur="handleBlur"
            :placeholder="$t('searchPlaceholder')"
          >
          <button @click="search">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" height="20px" width="20px">
              <path
                d="M4 9a5 5 0 1110 0A5 5 0 014 9zm5-7a7 7 0 104.2 12.6.999.999 0 00.093.107l3 3a1 1 0 001.414-1.414l-3-3a.999.999 0 00-.107-.093A7 7 0 009 2z"
                fill-rule="evenodd"
                fill="#17202A"
              ></path>
            </svg>
          </button>
          <div v-if="isSearching" class="search-results debug-list">
            <ul v-if="result.length">
              <li v-for="item in result" :key="item.id || item.localId" @click="editNotepad(item)">
                <span v-html="parseContent(item.title || $t('Untitled'))"></span>
              </li>
            </ul>
            <div v-else class="no-results">无匹配的笔记</div>
          </div>
          <div v-if="isShow" class="autocomplete-results debug-list">
            <ul v-if="data.length">
              <li v-for="item in data" :key="item.id || item.localId" @click="editNotepad(item)">
                <span v-html="parseContent(item.title || '无标题')"></span>
              </li>
            </ul>
            <div v-else class="no-results">无匹配的笔记</div>
          </div>
        </div>
        <div>
          <h3 class="resource"></h3>
          <div>
            <div class="Version_cover" v-if="VersionFlag">
              <div class="center_box">
                <h3>发现新版本</h3>
                <div class="explain" v-html="VersionExplain"></div>
                <div class="btn" @click="upgrade">前往升级</div>
                <div class="close-btn" @click="closeVersionCover">×</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loading" class="loading">{{ $t('Loading...') }}</div>
        <div v-else-if="error" class="error">{{ error }}</div>
        <div v-else-if="!notepadList.length && !isSearching" class="empty">暂无笔记</div>
        <div v-else-if="!isSearching">
          <div v-for="(notepad, index) in notepadList" :key="notepad.id || notepad.localId" class="notepad-item" @click.stop="editNotepad(notepad)">
            <div class="notepad-content">
              <h3 v-html="parseContent(notepad.title || '无标题')"></h3>
              <p v-html="parseContent(notepad.content || '无内容')"></p>
              <span>{{ formatTime(notepad.time) }}</span>
              <span v-if="!isLoggedIn" class="local-tag">本地笔记</span>
              <span v-else-if="notepad.is_encrypted" class="encrypted">已加密</span>
              <span v-else>版本: {{ notepad.version }}</span>
            </div>
            <div class="action-layout">
              <el-button type="danger" size="small" @click.stop="deleteNotepad(notepad, index)">
                <svg t="1746710518415" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12005" width="20" height="20">
                  <path d="M512 883.2A371.2 371.2 0 1 0 140.8 512 371.2 371.2 0 0 0 512 883.2z m0 64a435.2 435.2 0 1 1 435.2-435.2 435.2 435.2 0 0 1-435.2 435.2z" fill="#1296db" p-id="12006"></path>
                  <path d="M557.056 512l122.368 122.368a31.744 31.744 0 1 1-45.056 45.056L512 557.056l-122.368 122.368a31.744 31.744 0 1 1-45.056-45.056L466.944 512 344.576 389.632a31.744 31.744 0 1 1 45.056-45.056L512 466.944l122.368-122.368a31.744 31.744 0 1 1 45.056 45.056z" fill="#1296db" p-id="12007"></path>
                </svg>
                {{ $t('delete') }}
              </el-button>
              <button class="share-btn" @click="showShareOptions(notepad, $event)">
                <svg t="1746711515511" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="32124" width="20" height="20">
                  <path d="M896 582.4a32 32 0 0 0-32 32v249.6H160V160h249.6a32 32 0 0 0 0-64H115.2a19.2 19.2 0 0 0-19.2 19.2v793.6a19.2 19.2 0 0 0 19.2 19.2h793.6a19.2 19.2 0 0 0 19.2-19.2V614.4a32 32 0 0 0-32-32z" fill="#1296db" p-id="32125"></path>
                  <path d="M908.8 96H601.6a32 32 0 0 0 0 64h217.152l-419.84 419.84a32 32 0 0 0 45.248 45.248l419.84-419.84V422.4a32 32 0 0 0 64 0V115.2a19.2 19.2 0 0 0-19.2-19.2z" fill="#1296db" p-id="32126"></path>
                </svg>
                {{ $t('share') }}
              </button>
              <!-- 新增分享模式 -->
              <div 
                class="share-options" 
                v-if="isShareOptionsVisible(notepad.id || notepad.localId)"
                ref="shareOptions"
                :class="{ show: isShareOptionsVisible(notepad.id || notepad.localId ) }"
              >
                <div class="share-option" @click.stop="shareAsTxt(notepad)">
                  <span>{{ $t('txt') }}</span>
                </div>
                <div class="share-option" @click.stop="shareAsImage(notepad)">
                  <span>{{ $t('img') }}</span>
                </div>
                <div class="share-option" @click.stop="shareAsPdf(notepad)">
                  <span>{{ $t('pdf') }}</span>
                </div>
              </div>

              <el-button size="small" @click.stop="toggleLockScreen(notepad)">
                {{ isLoading ? '取消加载' : '加载锁屏' }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CryptoJS from 'crypto-js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import navigation from '../components/navigation.vue';

const axiosInstance = axios.create({
  baseURL: 'https://a.410121.xyz/api',
  timeout: 10000,
});

export default {
  components: {
    navigation
  },
  data() {
    return {
      notepadList: [],
      showActions: null,
      isLoading: false,
      loading: false,
      error: null,
      keywords: '',
      result: [], // 搜索结果
      data: [],   // 自动补全结果
      isShow: false,
      isSearching: false,
      isPageLoaded: false,
      searchHistory: [],
      VersionFlag: false,
      VersionExplain: '',
      currentVersion: '1.0',
      versionFileUrl: '',
      searchTimeout: null,
      encryptionKey: '92fa6b717f5767c7', // 与 Edit.vue 一致
      visibleShareIds: [],
      isLoggedIn: false,
    };
  },
  mounted() {
    this.isPageLoaded = true;
    const token = localStorage.getItem('token');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    console.log('检查登录状态，Token:', token, 'isLoggedIn:', isLoggedIn);
    this.isLoggedIn = !!isLoggedIn && !!token; // 更新登录状态

    if (!this.isLoggedIn) {
      console.log('未登录，使用本地存储');
      this.loadLocalNotepads(); // 未登录加载本地笔记
    } else {
      this.loadNotepads(); // 登录使用 API
    }
    

    this.checkVersion();
  },
  methods: {
    // 检查分享面板是否可见
    isShareOptionsVisible(id) {
      return this.visibleShareIds.includes(id);
    },
    
    // 显示分享选项
    showShareOptions(notepad, event) {
      event.stopPropagation();
      const noteId = notepad.id || notepad.localId;
      const index = this.visibleShareIds.indexOf(noteId);
      
      if (index > -1) {
        this.visibleShareIds.splice(index, 1);
      } else {
        this.visibleShareIds = [noteId];
      }
    },

    parseContent(content, isEncrypted = false) {
      if (!content) return '';
      
      // 处理加密内容
      let processedContent = isEncrypted ? this.decryptData(content, true) : content;
      
      // 限制长度为100个字符
      if (processedContent.length > 100) {
        processedContent = processedContent.substring(0, 100) + '...';
      }
      
      return processedContent;
    },

    // 解密数据
    decryptData(encryptedData, isEncrypted) {
      if (!encryptedData || typeof encryptedData !== 'string' || !isEncrypted) return encryptedData;

      // 兼容 CryptoJS Base64 格式
      if (encryptedData.startsWith('U2FsdGVkX1')) {
        try {
          const bytes = CryptoJS.AES.decrypt(encryptedData, this.encryptionKey);
          return bytes.toString(CryptoJS.enc.Utf8) || encryptedData;
        } catch (error) {
          console.error('CryptoJS 解密失败:', error);
          return encryptedData;
        }
      }

      // 兼容后端 hex 格式 (iv:encrypted)
      if (encryptedData.includes(':')) {
        try {
          const [ivHex, encryptedHex] = encryptedData.split(':');
          const iv = CryptoJS.enc.Hex.parse(ivHex);
          const encrypted = CryptoJS.enc.Hex.parse(encryptedHex);
          const key = CryptoJS.enc.Hex.parse(this.encryptionKey);
          const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encrypted },
            key,
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
          );
          return decrypted.toString(CryptoJS.enc.Utf8) || encryptedData;
        } catch (error) {
          console.error('Hex 格式解密失败:', error);
          return encryptedData;
        }
      }

      return encryptedData;  // 如果失败，返回原密文
    },

    async loadNotepads() {
      this.loading = true;
      try {
        const response = await axios.get('https://a.410121.xyz/api/notepads', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        if (response.data.code === 200) {
          this.notepadList = response.data.data.map(note => ({
            ...note,
            title: this.decryptData(note.title, note.is_encrypted),
            content: this.decryptData(note.content, note.is_encrypted),
            time: note.time ? note.time : '无时间', // 确保 time 有默认值
            updated_at: note.updated_at ? note.updated_at : '无更新时间'
          }));
          console.log('加载笔记:', this.notepadList); // 调试输出
        } else {
          this.error = response.data.message;
        }
      } catch (error) {
        this.error = '加载笔记失败: ' + error.message;
        console.error('加载笔记错误:', error);
      } finally {
        this.loading = false;
      }
    },

    editNotepad(notepad) {
      // 确保notepad存在且有有效的ID
      if (!notepad) {
        this.$message.error('无效的笔记数据');
        return;
      }
      
      const noteId = notepad.id || notepad.localId;
      console.log('编辑笔记，ID:', noteId);
      
      if (!noteId) {
        this.$message.error('无效的笔记 ID');
        return;
      }
      
      this.isShow = false;
      this.isSearching = false;
      this.keywords = '';
      this.result = [];
      this.data = [];
      
      if (!this.isLoggedIn) {
        this.$router.push({ name: 'NotepadEdit', params: { id: notepad.localId } }); // 使用本地ID
      } else {
        this.$router.push({ name: 'NotepadEdit', params: { id: notepad.id } });
      }
    },

    // 添加到 methods 中
    shareAsTxt(notepad) {
    let text = `标题: ${notepad.title || '无标题'}\n内容: ${this.parseContent(notepad.content, notepad.is_encrypted)}\n时间: ${this.formatTime(notepad.time)}\n`;

    // 处理图片
    if (notepad.image_urls && notepad.image_urls.length) {
      text += '\n图片:\n';
      notepad.image_urls.forEach((url, i) => {
        text += `${i+1}. ${url.startsWith('data:') ? '(本地base64图片)' : url}\n`;
      });
    }

    // 处理文件（支持base64或URL）
    if (notepad.file_urls && notepad.file_urls.length) {
      text += '\n文件:\n';
      notepad.file_urls.forEach((url, i) => {
        const name = notepad.original_file_names ? notepad.original_file_names[i] : `文件${i+1}`;
        text += `${i+1}. ${name} - ${url.startsWith('data:') ? '(本地base64文件)' : url}\n`;
      });
    }

    // 生成blob下载
    const blob = new Blob([text], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${notepad.title || '笔记'}.txt`;
    link.click();
    URL.revokeObjectURL(link.href);
  },

  shareAsImage(notepad) {
    // 使用html2canvas捕获笔记内容为图片
    const element = document.createElement('div');  // 临时DOM
    element.innerHTML = `
      <h3>${notepad.title || '无标题'}</h3>
      <p>${this.parseContent(notepad.content, notepad.is_encrypted)}</p>
      <span>${this.formatTime(notepad.time)}</span>
    `;

    // 添加图片（base64或URL）
    if (notepad.image_urls) {
      notepad.image_urls.forEach(url => {
        const img = document.createElement('img');
        img.src = url;
        img.style.width = '100px';
        element.appendChild(img);
      });
    }

    // 文件只加名称（图片分享不嵌入文件）
    if (notepad.file_urls) {
      const fileList = document.createElement('ul');
      notepad.file_urls.forEach((url, i) => {
        const name = notepad.original_file_names ? notepad.original_file_names[i] : `文件${i+1}`;
        const li = document.createElement('li');
        li.textContent = name;
        fileList.appendChild(li);
      });
      element.appendChild(fileList);
    }

    document.body.appendChild(element);  // 临时添加以捕获
    html2canvas(element).then(canvas => {
      canvas.toBlob(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${notepad.title || '笔记'}.png`;
        link.click();
        URL.revokeObjectURL(link.href);
      });
      document.body.removeChild(element);
    }).catch(err => {
      this.$message.error('生成图片失败: ' + err.message);
    });
  },

  shareAsPdf(notepad) {
    // 使用jsPDF生成PDF
    const doc = new jsPDF();
    let y = 10;
    doc.text(`标题: ${notepad.title || '无标题'}`, 10, y);
    y += 10;
    doc.text(`内容: ${this.parseContent(notepad.content, notepad.is_encrypted).replace(/<[^>]+>/g, '')}`, 10, y);  // 去除HTML
    y += 10;
    doc.text(`时间: ${this.formatTime(notepad.time)}`, 10, y);
    y += 10;

    // 添加图片（base64或URL）
    if (notepad.image_urls) {
      notepad.image_urls.forEach((url, i) => {
        try {
          doc.addImage(url, 'JPEG', 10, y, 50, 50);  // 支持base64
          y += 60;
        } catch (e) {
          doc.text(`图片${i+1}: (无法嵌入)`, 10, y);
          y += 10;
        }
      });
    }

    // 添加文件（作为链接或名称，base64文件生成blob链接但PDF不支持直接嵌入大文件）
    if (notepad.file_urls) {
      doc.text('文件:', 10, y);
      y += 10;
      notepad.file_urls.forEach((url, i) => {
        const name = notepad.original_file_names ? notepad.original_file_names[i] : `文件${i+1}`;
        if (url.startsWith('data:')) {
          // base64文件：生成临时blob并加文本提示（PDF不嵌入）
          doc.text(`${name}: (本地文件，请单独下载)`, 10, y);
        } else {
          doc.text(`${name}: ${url}`, 10, y);
        }
        y += 10;
      });
    }

    doc.save(`${notepad.title || '笔记'}.pdf`);
  },

    shareNotepad(notepad) {
      const shareText = `标题: ${this.parseContent(notepad.title, notepad.is_encrypted).replace(/<[^>]+>/g, '')}\n内容: ${this.parseContent(notepad.content, notepad.is_encrypted).replace(/<[^>]+>/g, '')}\n加密: ${notepad.is_encrypted ? '是' : '否'}\n版本: ${notepad.version}`;
      
      navigator.clipboard.writeText(shareText).then(() => {
        this.$message.success('已复制到剪贴板');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },

    loadLocalNotepads() {
      this.loading = true;
      try {
        const localData = JSON.parse(localStorage.getItem('localNotepads') || '[]');
        // 这里加一层判断：确保 note 是对象，避免异常数据导致的错误
        this.notepadList = localData.map(note => {
          if (!note) return { title: '', content: '', is_encrypted: false, localId: Date.now().toString() }; // 过滤 null/undefined，生成临时ID
          // 确保本地笔记有localId
          if (!note.localId) {
            note.localId = note.id || Date.now().toString();
          }
          return {
            ...note,
            title: this.decryptData(note.title, note.is_encrypted),
            content: this.decryptData(note.content, note.is_encrypted),
          };
        });
        
        if (this.notepadList.length > 5) {
          this.notepadList = this.notepadList.slice(0, 5);
          this.$confirm('本地笔记已满（限5条），请登录以使用更多功能，或付费解锁无限本地存储。', '提示', {
            confirmButtonText: '登录',
            cancelButtonText: '其它操作',
            type: 'warning'
          }).then(() => {
            this.$router.push('/login');
          }).catch(() => {
            this.$confirm('请选择操作：付费解锁被限制内容，或删除笔记。', '选择操作', {
              confirmButtonText: '付费',
              cancelButtonText: '删除',
              type: 'info',
            }).then(() => {
              window.location.href = 'https://afdian.com/a/xkkie'; // 外部链接用 location.href
              this.$message.info('请在爱发电页面完成付费，付费后将解锁无限存储');
            }).catch(() => {
              this.$router.push('/');
              this.$message.info('请删除部分旧笔记后再添加新笔记');
            });
          });
        }
      } catch (error) {
        this.error = '加载本地笔记失败';
        this.$message.error('加载本地笔记失败');
      } finally {
        this.loading = false;
      }
    },

    async deleteNotepad(notepad, index) {
      this.$confirm('确定要将该记事移到回收站吗？', '提示', { type: 'warning' })
        .then(async () => {
          try {
            const token = localStorage.getItem('token');
            if (!token) {
              // 未登录：直接本地删除，无回收站
              if (confirm('确定永久删除该本地笔记吗？（无回收站）')) {
                let localData = JSON.parse(localStorage.getItem('localNotepads') || '[]');
                localData.splice(index, 1); // 删除
                localStorage.setItem('localNotepads', JSON.stringify(localData));
                this.notepadList.splice(index, 1);
                this.$message.success('本地笔记已删除');
              }
            } else {
              const response = await axios.delete(`https://a.410121.xyz/api/notepads/${notepad.id}`, {
                headers: { Authorization: `Bearer ${token}` }
              });
              if (!this.isLoggedIn) {
                // 未登录：直接本地删除，无回收站
              } else if (response.data.code === 200) {
                this.notepadList.splice(index, 1);
                this.$message.success('已移到回收站');
              } else {
                throw new Error(response.data.message || '移动到回收站失败');
              }
            }
          } catch (error) {
            let message = error.response?.data?.message || error.message || '网络错误';
            if (error.code === 'ECONNABORTED') {
              message = '请求超时，请检查网络或服务器状态';
            } else if (error.response?.status === 401) {
              message = '认证失败，请重新登录';
              console.log('认证失败，跳转到登录页');
              localStorage.removeItem('isLoggedIn');
              localStorage.removeItem('userId');
              localStorage.removeItem('username');
              localStorage.removeItem('token');
              this.$router.push('/login');
            }
            this.$message.error(`移动到回收站失败: ${message}`);
          }
        })
        .catch(() => {});
    },

    toggleLockScreen(notepad) {
      this.isLoading = !this.isLoading;
      if (this.isLoading) {
        this.showNotification(notepad);
        this.$message.success('已加载锁屏文本');
      } else {
        this.$message.success('已取消加载文本');
      }
    },

    showNotification(notepad) {
      if ('Notification' in window) {
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            new Notification(this.parseContent(notepad.title, notepad.is_encrypted).replace(/<[^>]+>/g, '') || '无标题', {
              body: this.parseContent(notepad.content, notepad.is_encrypted).replace(/<[^>]+>/g, '') || '无内容',
              icon: 'path/to/icon.png'
            });
          }
        });
      }
    },

    async search() {
      if (!this.keywords.trim()) return;
      this.isSearching = true;
      try {
        const response = await axios.get(`https://a.410121.xyz/api/notepads?query=${encodeURIComponent(this.keywords)}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        if (response.data.code === 200) {
          this.result = response.data.data.map(note => ({
            ...note,
            title: this.decryptData(note.title, note.is_encrypted),
            content: this.decryptData(note.content, note.is_encrypted),
            time: note.time ? note.time : '无时间'
          }));
        } else {
          this.result = [];
        }
      } catch (error) {
        console.error('搜索失败:', error);
        this.result = [];
      }
    },

    getData(event) {
      if (!this.isPageLoaded) return;
      if (event.keyCode === 13) {
        this.isShow = false;
        this.search();
        return;
      }
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.isShow = true;
      this.searchTimeout = setTimeout(() => {
        this.performSearch();
      }, 300);
    },

    async performSearch() {
      if (!this.keywords.trim()) {
        this.isShow = false;
        this.data = [];
        this.isSearching = false;
        return;
      }
      this.isSearching = true;
      const token = localStorage.getItem('token');
      if (!token) {
        this.$message.error('用户未登录，请先登录');
        this.$router.push('/login');
        return;
      }
      try {
        const response = await axios.get('https://a.410121.xyz/api/notepads/search', {
          params: { query: this.keywords.trim() },
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log('自动补全响应:', response.data);
        if (response.data.code === 200) {
          this.data = (response.data.data || []).map(note => ({
            ...note,
            title: this.decryptData(note.title, note.is_encrypted),
            content: this.decryptData(note.content, note.is_encrypted),
            time: note.time ? note.time : '无时间'
          }));
        } else {
          throw new Error(response.data.message || '实时搜索失败');
        }
      } catch (error) {
        console.error('实时搜索请求失败:', error);
        let message = error.response?.data?.message || error.message || '实时搜索失败';
        if (error.response?.status === 401) {
          message = '认证失败，请重新登录';
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('userId');
          localStorage.removeItem('username');
          localStorage.removeItem('token');
          this.$router.push('/login');
        }
        this.$message.error(message);
      }
    },

    handleBlur() {
      setTimeout(() => {
        this.isShow = false;
      }, 200);
    },

    ressetSearch(kw) {
      this.keywords = kw;
      this.isShow = false;
      this.search();
    },

    checkVersion() {
      console.log('版本检查已禁用，等待后端实现 /note/check-version');
    },

    upgrade() {
      const link = document.createElement('a');
      link.href = this.versionFileUrl;
      link.download = 'uno.apk';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$message.success('下载完成，请手动安装新版本');
    },

    closeVersionCover() {
      this.VersionFlag = false;
    },

    formatTime(time) {
      if (!time || time === '1970-01-01 00:00:00' || time === '无时间') return '无时间';
      try {
        const date = new Date(time);
        if (isNaN(date.getTime())) {
          console.warn('无效时间格式:', time);
          return '无时间';
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，+1并补零
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error('时间格式化错误:', error, '输入:', time);
        return '无时间';
      }
    },
  },
  created() {
    this.checkVersion();
  }
};
</script>

<style scoped>
.w {
	width: 1700px;
	margin: 0 auto;
}
img {
  width: 100%;
  height: 100%;
  display: block;
}
#home {
  width: 100%;
}
#contentBox {
  width: 100%;
  height: 100%;
  position: relative;
  background-repeat: no-repeat;
  overflow: visible; /* 确保不裁剪子元素 */
  z-index: 0;
}
.registervideoContainer {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 0rem;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
  background-image: url(../assets/2.jpg);
  filter: blur(6px);
}
.resource {
  margin-left: 38%;
  font-size: 35px;
  color: #054e61b4;
}
.top {
  margin-top: 20px;
  margin-left: 13%;
  margin-top: 0%;
}
.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 18%;
  margin-top: 20px;
  margin-left: 10%;
}
.notepad-item {
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  margin-left: 6%;
  margin-top: 2%;
}
.notepad-content h3 {
  margin: 0;
}
.notepad-content p {
  margin: 5px 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notepad-content span {
  font-size: 0.8em;
  color: #666;
}
.action-layout {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}
.shousuo {
  margin-left: 6%;
  margin-top: 1%;
  display: flex;
  align-items: center;
  position: relative;
  width: 300px;
  z-index: 1000; /* 确保搜索框高于其他元素 */
}
.shousuo input {
  width: 100%;
  padding: 10px 16px;
  font-size: 16px;
  border: none;
  border-radius: 20px;
  background: #fff; /* 简化背景 */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s;
}
.shousuo input:focus {
  outline: none;
  box-shadow: 0 0 8px rgba(79, 181, 219, 0.5);
}
.input__search {
  width: 100%;
}
.shousuo button {
  padding: 10px;
  margin-left: -40px;
  background: #4bd5db;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s, transform 0.2s;
}
.shousuo button:hover {
  background: #00a7b3;
  transform: scale(1.1);
}
.shousuo button svg {
  width: 20px;
  height: 20px;
}
.search-results,
.autocomplete-results {
  position: absolute;
  top: 40px; /* 固定值，考虑输入框高度 */
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 250px;
  overflow-y: auto;
  z-index: 20000; /* 最高层级 */
}
.search-results ul,
.autocomplete-results ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.search-results li,
.autocomplete-results li {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background 0.2s, color 0.2s;
}
.search-results li:hover,
.autocomplete-results li:hover {
  background: #e6f7ff;
  color: #4bd5db;
}
.no-results {
  padding: 12px 16px;
  font-size: 14px;
  color: #666;
  text-align: center;
}
.avatar {
  margin-top: -1.1%;
  margin-left: 90%;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
input,
textarea {
  user-select: auto;
}
.addCard .van-field__control {
  color: #b1b1b1;
}
.Version_cover {
  width: 100%;
  height: 100vh;
  background: #000000b3;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
}
.Version_cover .center_box {
  width: 15%;
  height: 15rem;
  border-radius: 0.533333rem;
  background: #7bbfd4af;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Version_cover .center_box h3 {
  width: 100%;
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  padding: 0.266666rem;
}
.Version_cover .center_box .explain {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  box-sizing: border-box;
  font-size: 1.2rem;
  opacity: 0.9;
}
.Version_cover .center_box .btn {
  width: 80%;
  height: 3rem;
  background: #ff4400b6;
  border-radius: 0.533333rem;
  font-size: 2rem;
  color: #ffffff;
  line-height: 3.066666rem;
  text-align: center;
  letter-spacing: 1px;
  position: absolute;
  bottom: 0.266666rem;
  left: 50%;
  transform: translateX(-50%);
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 33px;
  color: #000000;
}
/* 分享 */
.share-options {
  position: absolute;
  top: 100%;
  right: 43%;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 10px 0;
  margin-top: 5px;
  min-width: 120px;
  z-index: 100;
}

.share-options.show {
  display: block;
}

.share-option {
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.share-option:hover {
  background-color: #f5f5f5;
}

/* 笔记项样式 */
.notepad-item {
  position: relative; /* 重要：确保分享面板定位正确 */
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  transition: box-shadow 0.2s;
}

.notepad-item:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

@media screen and (max-width: 1600px) {
  .w {
    max-width: 1400px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1400px) {
  .w {
    max-width: 1200px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
  .shousuo {
    margin-left: 10%;
    width: 280px;
  }
}
@media screen and (max-width: 1200px) {
  .w {
    max-width: 1000px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
  .shousuo {
    margin-left: 8%;
    width: 250px;
  }
}
@media screen and (max-width: 1000px) {
  .w {
    max-width: 100%;
  }
  .shousuo {
    margin-left: 6%;
    width: 90%;
    max-width: 400px;
  }
  .search-results,
  .autocomplete-results {
    top: 40px;
    width: 100%;
    left: 0;
    border-radius: 8px;
  }
}
@media screen and (max-width: 550px) {
  .w {
    max-width: 100%;
  }
  .shousuo {
    margin-left: 4%;
    margin-right: 4%;
    width: calc(100% - 8%);
  }
  .search-results,
  .autocomplete-results {
    top: 48px; /* 增加间距适应小屏幕 */
    width: 100%;
    left: 0;
    border-radius: 8px;
  }
  .Version_cover .center_box {
    width: 85%;
    height: 15rem;
    border-radius: 0.533333rem;
    background: rgba(123, 191, 212, 0.685);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>